import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import CustomerLayout from './layouts/CustomerLayout';
import TenantLayout from './layouts/TenantLayout';
import Dashboard from './pages/Dashboard';
import Manifests from './pages/Manifests';
import Invoices from './pages/Invoices';
import KPLMix from './pages/KPLMix';
import Profitability from './pages/Profitability';
import Couriers from './pages/Couriers';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import Documentation from './pages/Documentation';
import Broadcast from './pages/Broadcast';

// Customer Portal Pages
import CustomerLogin from './customer/CustomerLogin';
import CustomerDashboard from './customer/CustomerDashboard';
import CustomerTracking from './customer/CustomerTracking';
import CustomerInvoices from './customer/CustomerInvoices';
import CustomerPayments from './customer/CustomerPayments';
import CustomerAddressBook from './customer/CustomerAddressBook';
import CustomerNotifications from './customer/CustomerNotifications';
import CustomerSettings from './customer/CustomerSettings';

// Tenant Portal Pages
import TenantLogin from './tenant/TenantLogin';
import TenantDashboard from './tenant/TenantDashboard';
import TenantShipments from './tenant/TenantShipments';
import TenantPackages from './tenant/TenantPackages';
import TenantIntake from './tenant/TenantIntake';
import TenantBOM from './tenant/TenantBOM';
import TenantInvoices from './tenant/TenantInvoices';
import TenantInvoiceSystem from './tenant/TenantInvoiceSystem';
import TenantCustomers from './tenant/TenantCustomers';
import TenantReports from './tenant/TenantReports';
import TenantNotifications from './tenant/TenantNotifications';
import TenantSettings from './tenant/TenantSettings';
import TenantWebsiteBuilder from './tenant/TenantWebsiteBuilder';
import TenantWebsitePreview from './tenant/TenantWebsitePreview';
import TenantBilling from './tenant/TenantBilling';
import TenantFinances from './tenant/TenantFinances';
import TenantDeliveryBoard from './tenant/TenantDeliveryBoard';
import TenantClients from './tenant/TenantClients';

// Admin Pages
import PlatformBilling from './pages/PlatformBilling';

function App() {
  return (
    <Routes>
      {/* Main Operations Hub */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="manifests" element={<Manifests />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="kpl-mix" element={<KPLMix />} />
        <Route path="profitability" element={<Profitability />} />
        <Route path="couriers" element={<Couriers />} />
        <Route path="platform-billing" element={<PlatformBilling />} />
        <Route path="broadcast" element={<Broadcast />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      {/* Customer Portal */}
      <Route path="/customer/login" element={<CustomerLogin />} />
      <Route path="/customer" element={<CustomerLayout />}>
        <Route index element={<Navigate to="/customer/dashboard" replace />} />
        <Route path="dashboard" element={<CustomerDashboard />} />
        <Route path="tracking" element={<CustomerTracking />} />
        <Route path="invoices" element={<CustomerInvoices />} />
        <Route path="payments" element={<CustomerPayments />} />
        <Route path="address" element={<CustomerAddressBook />} />
        <Route path="notifications" element={<CustomerNotifications />} />
        <Route path="settings" element={<CustomerSettings />} />
      </Route>

      {/* Tenant Portal */}
      <Route path="/tenant/login" element={<TenantLogin />} />
      <Route path="/tenant" element={<TenantLayout />}>
        <Route index element={<Navigate to="/tenant/dashboard" replace />} />
        <Route path="dashboard" element={<TenantDashboard />} />
        <Route path="packages" element={<TenantPackages />} />
        <Route path="intake" element={<TenantIntake />} />
        <Route path="bom" element={<TenantBOM />} />
        <Route path="invoices" element={<TenantInvoiceSystem />} />
        <Route path="shipments" element={<TenantShipments />} />
        <Route path="customers" element={<TenantCustomers />} />
        <Route path="reports" element={<TenantReports />} />
        <Route path="billing" element={<TenantBilling />} />
        <Route path="finances" element={<TenantFinances />} />
        <Route path="delivery-board" element={<TenantDeliveryBoard />} />
        <Route path="clients" element={<TenantClients />} />
        <Route path="notifications" element={<TenantNotifications />} />
        <Route path="website" element={<TenantWebsiteBuilder />} />
        <Route path="settings" element={<TenantSettings />} />
      </Route>
      
      {/* Tenant Website Preview (standalone) */}
      <Route path="/site/:tenantSlug" element={<TenantWebsitePreview />} />
      <Route path="/site-preview" element={<TenantWebsitePreview />} />
      
      {/* Documentation */}
      <Route path="/docs/*" element={<Documentation />} />
    </Routes>
  );
}

export default App;
